/* LoadingState.tsx generated by @compiled/babel-plugin v3.0.1 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._2Y7lL45zaO%7Bpadding-inline%3Avar(--ds-space-200%2C1pc)%7D");
import React from 'react';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { ListItemSkeleton } from '@atlassian/home-list-ui/skeleton';
const styles = {
  padding: "_2Y7lL45zaO"
};
type Props = {
  withPadding?: boolean;
};
export const LoadingState = ({
  withPadding = false
}: Props): React.ReactNode => {
  return <Stack xcss={withPadding ? styles.padding : undefined}>
			<ListItemSkeleton />
			<ListItemSkeleton />
			<ListItemSkeleton />
			<ListItemSkeleton />
			<ListItemSkeleton />
		</Stack>;
};